import { type BlogCategories } from '#app/components/BlogCategoriesInput/types.js';
import { CategoryTag } from '#app/components/CategoryTag/CategoryTag.js';
import { getExpectedCategoriesForUser } from './util.js';
import { useMemo } from 'react';

type BlogCategoriesListProps = {
  readonly asLinks?: boolean;
  readonly categories: BlogCategories;
  readonly displayUsername?: string;
  readonly hideGroupingCategories?: boolean;
  readonly limit?: number;
  readonly selectedCategory?: null | string;
  readonly size?: 'large' | 'small';
};

export const BlogCategoriesList = ({
  asLinks = false,
  categories,
  displayUsername = 'TheContrarian',
  limit,
  selectedCategory = null,
  size = 'large',
}: BlogCategoriesListProps) => {
  const categoriesToDisplay = useMemo(() => {
    return getExpectedCategoriesForUser({
      categories,
    });
  }, [categories]);

  if (!categoriesToDisplay.length) {
    return null;
  }

  const blogCategoriesList = limit
    ? categoriesToDisplay.slice(0, limit)
    : categoriesToDisplay;

  const delta = limit
    ? categoriesToDisplay.length - blogCategoriesList.length
    : 0;

  const displayDelta = delta > 0;

  return (
    <>
      {blogCategoriesList.map(({ id, name }) => {
        return (
          <CategoryTag
            asLink={asLinks}
            displayUsername={displayUsername}
            highlighted={
              id === 'all' && selectedCategory === null
                ? true
                : id === selectedCategory
            }
            id={id}
            key={id}
            label={name}
            size={size}
          />
        );
      })}
      {displayDelta ? (
        <CategoryTag
          displayUsername={displayUsername}
          id="category-delta"
          key="category-delta"
          label={`+${delta}`}
          size={size}
        />
      ) : null}
    </>
  );
};
